/**
 * created by tian ruo jun
 * 3.5 table 页统一样式
 * columns 表头
 * dataSource 数据
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table} from "antd";
import moment from "moment";

export default class BaseTable extends Component {
    static defaultProps = {
        columns: [],
        dataSource: [],
        rowSelection:null
    };
    static propTypes = {
        /**
         * @text 表头
         * @category array
         */
        columns: PropTypes.array.isRequired,
        /**
         * @text 表数据
         * @category array
         */
        dataSource: PropTypes.array.isRequired,
        /**
         * 	表格行是否可选择配置
         */
        rowSelection: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {}

    componentDidMount() {}

    render() {
        let {columns, dataSource} = this.props;
        return (
            <div className={'statistics_table'}>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    // scroll={{ x: 'max-content' }}
                    rowClassName={(record, index) => {
                        let className = 'myTableOddRow';
                        if (index % 2 === 1) className = 'myTableEvenRow';
                        return className;
                    }}
                    // scrollToFirstRowOnChange
                    // onHeaderRow={column => {
                    //     return {
                    //         style: {backgroundColor: 'rgb(245, 248, 252)'}, // 点击表头行
                    //     };
                    // }}
                    {...this.props}
                    rowKey={this.props.rowKey}
                />
                <style>
                    {`
                        .myTableEvenRow {
                            background-color: rgb(245, 248, 252);
                        }
                        .myTableOddRow {
                            background-color: #ffffff;
                        }
                        .statistics_table .ant-table-fixed-left,.statistics_table .ant-table-fixed-right {
                        height:calc(100% - 8px)
                        }
                        .statistics_table .ant-table-header {
                        background:#fff !important;
                        }
                        .statistics_table .ant-table-header {
                        min-width: 0 !important;
                        }
                        .statistics_table ::-webkit-scrollbar-thumb {
                           border-radius: 10px !important;
                           background: rgba(0, 0, 0, 0.2);
                       }
                       .statistics_table ::-webkit-scrollbar {
                          height: 8px;
                          width: 8px;
                        }
                    `}
                </style>
            </div>
        )
    }

}
